import { createContext, useContext, useState } from "react";

const AudioContext = createContext();

export const AudioProvider = ({ children }) => {
  const [allMuted, setAllMuted] = useState(false);

  return (
    <AudioContext.Provider value={{ allMuted, setAllMuted }}>
      {children}
    </AudioContext.Provider>
  );
};

export const useAudio = () => useContext(AudioContext);